import { render, staticRenderFns } from "./BioSettings.vue?vue&type=template&id=f3094f54&scoped=true&"
import script from "./BioSettings.vue?vue&type=script&lang=js&"
export * from "./BioSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3094f54",
  null
  
)

export default component.exports